<template>
    <div>
        <div class="actions__container">
            <div class="flex items-center gap-2">
                <router-link
                    class="btn btn-primary w-40 inline-block mr-1 mb-2"
                    :to="{ name: 'attraction-create', query: $route.query }"
                >
                    Создать
                </router-link>

                <CruiseTypeChoose
                    :types="getCruiseTypes"
                    :is-loading="isCruiseTypesLoading"
                    @on-type-click="handleTypeClick"
                />
            </div>
        </div>

        <ContentSearch />

        <ContentTable
            :table-actions="tableActions"
            :headers="tableHeaders"
            :table-rows="tableData"
            :meta="pagination"
            :loading="loading"
            @edit="editAction"
            @delete="deleteAction"
        />

        <PopupDeleteModal
            :is-open="modalDeleteOpen"
            :entity-name="modalDeleteCaption"
            :modal-data="modalDeleteRow"
            @update:isOpen="modalDeleteOpen = $event"
            @deleteModalAccepted="onDeleteModalAccepted"
        />
    </div>
</template>

<script>
import ContentTable from '@/components/tables/ContentTable';
import PopupDeleteModal from '@/components/modals/PopupDeleteModal';
import CruiseTypeChoose from '@/components/CruiseTypes/CruiseTypeChoose.vue';
import { errorResponse } from '@/mixins/form/form-mixin';
import ContentSearch from '@/components/base/ContentSearch';
import { mapGetters } from 'vuex';
import { pageMixin } from '@/mixins/pageMixin';
import { cruiseTypesOptionsMixin } from '@/mixins/form/cruise-types-options.mixin';

export default {
    components: { ContentSearch, PopupDeleteModal, ContentTable, CruiseTypeChoose },
    mixins: [errorResponse, pageMixin, cruiseTypesOptionsMixin],
    async beforeRouteUpdate(to, from, next) {
        await this.fetchData({ type: this.getCruiseTypes[0].id, ...to.query });
        next();
    },
    data() {
        return {
            tableActions: [
                { name: 'edit', title: 'редактировать', icon: 'Edit2Icon', cbName: 'edit' },
                { name: 'delete', title: 'удалить', class: 'bg-red-400', icon: 'Trash2Icon', cbName: 'delete' },
            ],
            addButtonDelete: false,
            tableHeaders: [
                { field: 'id', label: '#' },
                { field: 'title', label: 'Название' },
            ],
            loading: false,
            tableData: [],
            pagination: null,
            modalDeleteOpen: false,
            modalDeleteCaption: null,
            modalDeleteRow: null,
        };
    },
    computed: {
        ...mapGetters({ getUser: 'user/getUser' }),
    },
    async created() {
        this.$store.commit('main/setPageHeader', 'Достопримечательности');

        if (!this.getCruiseTypes.length) await this.fetchCruiseTypes();
        if (this.$route.query.type === undefined) {
            await this.$router.push({ query: { type: this.getCruiseTypes[0].id, ...this.$route.query } });
        } else {
            await this.fetchData({ type: this.getCruiseTypes ? this.getCruiseTypes[0]?.id : 0, ...this.$route.query });
        }
    },
    methods: {
        async fetchData(params) {
            try {
                this.loading = true;
                const { data } = await this.axios.get('/attractions', { params });
                this.tableData = data.data;
                this.pagination = data.meta;

                const rolesCanDestroyPosts = this.$route.meta.destroy_posts ?? [];

                if (rolesCanDestroyPosts.includes(this.getUser.role) && !this.addButtonDelete) {
                    const buttonDelete = {
                        name: 'delete',
                        title: 'удалить',
                        class: 'bg-red-400',
                        icon: 'Trash2Icon',
                        cbName: 'delete',
                    };

                    this.tableActions.push(buttonDelete);
                    this.addButtonDelete = true;
                }

                this.loading = false;
            } catch (ex) {
                this.loading = false;
                console.log('cant fetch data: ' + ex);
            }
        },
        editAction(row) {
            // this.$router.push({ name: 'attraction-edit', params: { id: row.id } });
            this._pMTransitionToEditPageWithQuery('attraction-edit', { id: row.id });
        },
        deleteAction(row) {
            this.modalDeleteOpen = true;
            this.modalDeleteCaption = 'достопримечательность';
            this.modalDeleteRow = row;
        },
        onDeleteModalAccepted(data) {
            this.axios
                .delete('/attractions/' + data.id)
                .then(() => {
                    this.fetchData(this.$route.query);
                    this.modalDeleteOpen = false;
                })
                .catch((ex) => {
                    this.errorResponse(ex);
                });
        },
        async handleTypeClick() {
            await this.fetchData(this.$route.query);
        },
    },
};
</script>

<style></style>
